// extracted by mini-css-extract-plugin
export var formInfo = "fc_Kp";
export var formInfo__image = "fc_Kj";
export var formInfo__link = "fc_Kn";
export var formInfo__list = "fc_Kl";
export var formInfo__sectionHr = "fc_Km";
export var formInfo__services = "fc_Kh";
export var formInfo__title = "fc_Kk";